module.exports = __webpack_public_path__ + "img/124.bd660b2c.png";